var React = require('react');

function LinkedInInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M7 4.014a2.006 2.006 0 0 1-2 2.014c-1.106 0-2-.899-2-2.014C3 2.901 3.894 2 5 2c1.106 0 2 .903 2 2.014ZM3 8.011V20h4V8.01H3Zm6 0h4v2.184c1.744-3.23 8-3.47 8 3.093V20h-3.996v-5.717c0-3.759-4.004-3.44-4.004 0V20H9V8.01Z","clipRule":"evenodd"}));
}

LinkedInInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","role":"img","aria-label":"LinkedIn"};

module.exports = LinkedInInline;

LinkedInInline.default = LinkedInInline;
